// OpenAPI 接入信息: 当前环境 + SDK/HTTP 该打的地址.
//
// 为什么要有它: API Token 页只发凭证, 拿到 token 的下游还得知道"往哪个域名发" ——
// 各环境地址不同 (dev / test / pre / 美服 prod / 国服 prod), 以前得口头问一遍.
// 两个信息都已经在前端构建期的环境变量里 (.env.<mode>), 直接取, 不必再问后端:
//   VITE_PASSPORT_ENV     环境标识 (dev / test / test_us / pre_us / prod-us / prod-cn)
//   VITE_REQUEST_BASE_URL 后端基址, 含网关前缀 /material (Istio 会剥掉再转给后端)
//
// SDK 的 baseURL 就是 VITE_REQUEST_BASE_URL 原值: material-client 内部自己拼 /openapi/v1
// (见 core.basePath), 所以页面上要分开展示"SDK 填这个"与"HTTP 打这个", 免得有人把
// /openapi/v1 也填进 SDK 造成路径重复.

/** OpenAPI 的路径前缀 (与 material-client core.basePath 一致). */
export const OPENAPI_BASE_PATH = '/openapi/v1';

// 环境标识 → 展示名. 这里的键是 VITE_PASSPORT_ENV 的取值域 (见各 .env.<mode> 文件),
// 未收录的原样显示 —— 新增环境时页面不会显示空白.
const ENV_LABEL: Record<string, string> = {
    dev: '开发 (dev)',
    test: '测试 (test)',
    test_us: '测试 · 美服 (test_us)',
    pre_us: '预发布 · 美服 (pre)',
    'prod-us': '生产 · 美服 (prod-us)',
    'prod-cn': '生产 · 国服 (prod-cn)',
};

export interface ApiEnvInfo {
    /** 环境标识原值 (VITE_PASSPORT_ENV) */
    env: string;
    /** 环境展示名 */
    envLabel: string;
    /** 是否生产环境 (页面据此提醒"这是生产 token") */
    isProd: boolean;
    /** SDK 的 baseURL: material-client 内部自己拼 /openapi/v1 */
    sdkBaseURL: string;
    /** 直接发 HTTP 时的完整前缀 */
    httpBaseURL: string;
}

export function apiEnvInfo(): ApiEnvInfo {
    const env = (import.meta.env.VITE_PASSPORT_ENV || '').trim();
    const base = (import.meta.env.VITE_REQUEST_BASE_URL || '').trim().replace(/\/$/, '');
    return {
        env,
        envLabel: ENV_LABEL[env] || env || '未配置',
        isProd: env.startsWith('prod'),
        sdkBaseURL: base,
        httpBaseURL: base + OPENAPI_BASE_PATH,
    };
}
